import React, { useEffect } from "react";

const TARGET_URL = "https://github.com/inboost-dev/inboost-ai-proxy-runtime";

export default function AiProxyRedirect() {
  useEffect(() => {
    window.location.replace(TARGET_URL);
  }, []);

  return (
    <main className="min-h-screen bg-page text-ink-text flex items-center justify-center p-6">
      <div className="glass rounded-3xl p-8 sm:p-10 max-w-lg w-full text-center">
        <div className="mono text-[10px] uppercase tracking-[0.22em] text-brand-cyan mb-4">
          InBoost AI Proxy
        </div>
        <h1 className="text-2xl sm:text-3xl font-heading font-bold tracking-tight mb-4">
          Перенаправление на InBoost AI Proxy Runtime...
        </h1>
        <p className="text-muted leading-relaxed mb-6 text-sm sm:text-base">
          Вы перенаправляетесь в официальный репозиторий проекта на GitHub.
        </p>
        <p className="text-xs text-muted">
          Если перенаправление не произошло автоматически:
          <br />
          <a
            href={TARGET_URL}
            className="text-brand-cyan hover:underline break-all mt-3 inline-block"
          >
            {TARGET_URL}
          </a>
        </p>
      </div>
    </main>
  );
}
